import { render, staticRenderFns } from "./ReactionIconButton.vue?vue&type=template&id=b45b70d8&scoped=true&lang=pug"
import script from "./ReactionIconButton.vue?vue&type=script&lang=ts"
export * from "./ReactionIconButton.vue?vue&type=script&lang=ts"
import style0 from "./ReactionIconButton.vue?vue&type=style&index=0&id=b45b70d8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45b70d8",
  null
  
)

export default component.exports